import { Heart } from 'lucide-react';

const ThankYouBanner = () => (
  <section
    className="relative overflow-hidden bg-[#2a0e16] text-white border-b border-[#d9a15b]/30"
    data-testid="thank-you-banner"
  >
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_left,rgba(217,161,91,0.14),transparent_55%)] pointer-events-none" />
    <div className="absolute inset-0 grain opacity-40 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-5 md:py-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
      <div className="flex items-start gap-3 md:gap-4 flex-1 min-w-0">
        <div className="shrink-0 mt-0.5 w-9 h-9 rounded-full bg-[#d9a15b]/15 border border-[#d9a15b]/40 flex items-center justify-center">
          <Heart className="w-4 h-4 text-[#d9a15b]" />
        </div>
        <div className="min-w-0">
          <p className="eyebrow text-[10px] text-[#d9a15b] tracking-[0.3em] mb-1.5">2026 Retreat · Thank You</p>
          <p className="font-display text-lg md:text-2xl leading-snug text-white/95" data-testid="thank-you-message">
            Thank you so much to everyone who came. It was an incredible weekend — the honesty, the laughter,
            the connection — and none of it happens without you showing up the way you did.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default ThankYouBanner;
